import React, { Component, Fragment } from "react";
import meImg from "../img/small-version.jpg";
import Footer from "./Footer";
import scene from "../img/scene2.jpg";
import scene2 from "../img/southend.jpg";
import ecpcImg from "../img/acm.jpg";
import meAtMeta from "../img/metaShaftsBerry.jpeg";
import tactful from "../img/tactful.jpg";

class About extends Component {
  render() {
    return (
      <Fragment>
        <div className="about-container">
          <div className="main-content-container">
            <div className="main-content-name">Abdelrahman AbouDeghedy</div>
            <div className="main-content-description">
              Graduate Software Engineer
            </div>
          </div>

          <div className="summary-content-container">
            <div className="summary-content-img">
              <img
                src={meImg}
                alt="Abdelrahman's img"
                className="summary-content-img-itself"
              />
              <div className="summary-content-img-text">B/W Abdelrahman</div>
            </div>
            <div className="summary-content-paragraph summary-content-paragraph-first">
              I'm a recent Electrical Engineering graduate from Alexandria
              University, continious-learner, writer, and in love with talking
              to people and hearing their stories.
            </div>
            <div className="summary-content-paragraph">
              I chose to be a software engineer because I really enjoy the
              process of solving problems, also the field is so versatile, and
              this gives me a huge challenge to work in.
            </div>
            <div className="summary-content-header">Experience</div>
            <div className="summary-content-paragraph">
              I was a software engineer intern @Meta in London last summer. I
              was in the Workplace Messaging team where I worked on two projects
              that aimed for increasing users’ productivity, one of them was one
              of the top 10 requested features in our 2022 papercuts. It
              increased the productivity of more than 50K employees by reducing
              their send message time.
            </div>
            <div className="summary-content-paragraph">
              I also wrote an efficient code that caused a significant speed up
              to the time of opening a thread by avoiding some useless
              re-renderers, which solved a common regression in the desktop
              application.
            </div>
            <div className="showoff-container showoff-container-scene">
              <img
                className="showoff-img-itself"
                src={meAtMeta}
                alt="Me at Meta shaftesbury, London"
              />
            </div>

            <div className="summary-content-paragraph">
              Before that, I was an SWE intern @Tactful AI, a data analytics
              startup. I worked on multiple projects such as creating a Visual
              Web tool to monitor helm charts’ releases, making a minimal
              version control system that compares different versions of YAML
              files, and showing analytics of Kubernetes clusters (such as
              pods/deployments/services).
            </div>
            <div className="summary-content-paragraph">
              I also worked on the multi-lang project on both the backend and
              the frontend sides, it added 20+ more languages to our system to
              be more accessible to a wider audience.
            </div>
            <div className="showoff-container showoff-container-scene">
              <img
                className="showoff-img-itself"
                src={tactful}
                alt="Me at Meta shaftesbury, London"
              />
            </div>

            <div className="summary-content-header">Hobbies</div>
            <div className="summary-content-paragraph">
              I love writing and communicating my thoughts. I'm currently
              writing at
              <a
                rel="noreferrer"
                className="resume-link link-inside"
                href="https://dev.to/abdelrahmandeghedy"
                target="_blank"
              >
                dev.to
              </a>
              check it out!.
            </div>
            <div className="summary-content-paragraph">
              Whenever I see a good scene, I always use my phone camera to
              capture it. Unfortunately, good moments always pass, but memories
              last forever. You can find more on my
              <a
                rel="noreferrer"
                className="resume-link link-inside"
                href="https://www.behance.net/Deghedy"
                target="_blank"
              >
                behance
              </a>
              account.
            </div>

            <div className="showoff-container showoff-container-scene">
              <img
                className="showoff-img-itself"
                src={scene2}
                alt="Southend on sea, Summer of 2022"
              />
            </div>
            <div className="showoff-container showoff-container-scene">
              <img
                className="showoff-img-itself"
                src={scene}
                alt="Beautiful Scene In my University"
              />
            </div>
            <div className="summary-content-header">Activities</div>
            <div className="summary-content-paragraph">
              I'm currently participating as a student rep in my department. I
              chose this, as it gives me a chance to help and connect with other
              students, and to build the community that I always strived for!
            </div>
            <div className="summary-content-paragraph">
              Last year, I participated in ECPC, as I fall in love with
              algorithms, and problem-solving; It was a nice experience, and I
              enjoyed working with my team. It gave me the chance to know
              beautiful personalities, and opened my mind to a lot of new ideas!
            </div>
            <div className="showoff-container showoff-img-itself-acm">
              <img
                className="showoff-img-itself"
                src={ecpcImg}
                alt="Me on the ECPC last year"
              />
            </div>
          </div>

          <Footer />
        </div>
      </Fragment>
    );
  }
}

export default About;
